import React from 'react'
import { useBenefits } from '../BenefitsProvider'
import { useTranslation } from '../../../hooks/useTranslation'
import { Button } from '~/components/_atoms/index'
import { CoachHeader, CoachHeaderLight } from '../CoachHeader'

const CoachServicesPage = ({ description, children }) => {
  const { coach, service_request_type, current_user } = useBenefits()
  const { t } = useTranslation('benefits_section')
  const { isLiaison, coach_first_name } = coach
  const { select, orientationCallCompleted } = current_user

  const introCallCompleted = orientationCallCompleted

  return (
    <div className="w-full gap-6 p-4 md:p-9">
      <div className="mb-4">
        <MessageCoachWrapper>
          <CoachHeader>
            <CoachHeaderLight>{t('title_light')} </CoachHeaderLight>
            {isLiaison ? t('title_dark_liaison') : t('title_dark')}
          </CoachHeader>
          {description ? (
            <div className="my-4">
              <p>{description}</p>
            </div>
          ) : isLiaison ? (
            <p>
              {select
                ? t('liaison_description_select')
                : t('liaison_description')}
            </p>
          ) : service_request_type !== 'orientation_call' &&
            !introCallCompleted ? (
            <p>
              {t('please_complete_intro_call', {
                coach_name: coach_first_name,
              })}
            </p>
          ) : (
            <p>{t('description')}</p>
          )}
        </MessageCoachWrapper>
      </div>
      {children}
    </div>
  )
}

export default CoachServicesPage

const MessageCoachWrapper = ({ children }) => {
  const { t } = useTranslation()
  const { coach } = useBenefits()
  const { isLiaison } = coach
  // const { serviceRequestList, select } = useBenefits()
  // const calendlyEvent =
  //   serviceRequestList['ServiceRequest::OrientationCall']?.calendly_event

  // const introCallScheduled =
  //   select && calendlyEvent && calendlyEvent['start_time']

  // if (introCallScheduled) {
  //   return (
  //     <div className="flex justify-between">
  //       <div>{children}</div>
  //       <Button
  //         color="secondary"
  //         className="open-chat-modal mb-10 self-start"
  //         data-toggle="modal"
  //         data-target="#coach_chat_list"
  //       >
  //         {t('message_coach')}
  //       </Button>
  //     </div>
  //   )
  // }

  return (
    <div className="flex justify-between">
      <div>{children}</div>
      {!isLiaison && (
        <Button
          color="secondary"
          className="mb-10 self-start"
          onClick={() => {
            window.location.href = '/coach_messages'
          }}
        >
          {t('message_coach')}
        </Button>
      )}
    </div>
  )
}
